module.exports = __webpack_public_path__ + "static/media/Eventy_B.8c3b7547.png";